import React from "react";
import "../styles/brandGuidelines.css";

const UIElements = () => {
  return (
    <div className="ui-elements">
      <h2>UI Elements</h2>
      <div className="button-example">
        <button className="primary-button">Primary Button</button>
        <button className="secondary-button">Secondary Button</button>
      </div>
      <div className="input-example">
        <input type="text" placeholder="Enter text" className="text-input" />
      </div>
      <div className="card-example">
        <div className="card">
          <h3>Card Title</h3>
          <p>
            This is a sample card component styled according to brand
            guidelines.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UIElements;
